// extracted by extract-css-chunks-webpack-plugin
module.exports = {"calculatorComp":"_3pJdUF","button":"nXFlBD","results":"_8zbUMs","label":"_2sHYL0","row":"_3j7J4l","rowRight":"_2jSYqE","infoBtn":"_29Qe0H","statusIcon":"_3a25Eu"};